/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import App from "App";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// Soft UI Context Provider
import { ArgonControllerProvider } from "context";

// react-perfect-scrollbar component

// react-perfect-scrollbar styles
import "react-perfect-scrollbar/dist/css/styles.css";
import 'rsuite/dist/rsuite.min.css';


const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <ArgonControllerProvider>

        <App />

    </ArgonControllerProvider>
  </BrowserRouter>
);
